import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match?.[1];
    if (!sessionId) { navigate("/admin", { replace: true }); return; }
    (async () => {
      try {
        await axios.post(`${API}/admin-auth/session`, { session_id: sessionId }, { withCredentials: true });
        window.history.replaceState({}, "", "/admin");
        navigate("/admin", { replace: true });
      } catch {
        navigate("/admin?e=1", { replace: true });
      }
    })();
  }, [navigate]);

  return <div className="min-h-screen flex items-center justify-center">Signing you in…</div>;
}
